import { Col, Form, Radio, Row, Space } from "antd";
import { FormInstance } from "antd/es/form";
import styled from "styled-components";
import Text from "../../../components/Text/Text";
import UploadFilePDFCreditLimit from "../../../components/UploadFile/uploadFileCreditLimit";
import { useEffect, useState } from "react";

interface ApprovalSectionProps {
  form: FormInstance;
  afterStatus: string;
  onFileUpload: (file: any) => void;
}

const Container = styled.div`
  margin: 8px 0 0 24px;
`;

const ApprovalSection: React.FC<any> = ({
  form,
  afterStatus,
  onFileUpload,
}: ApprovalSectionProps) => {
  const [isActive, setIsActive] = useState<string>("");
  const pathFile = form.getFieldValue("file");

  return (
    <Container>
      <Text fontFamily='IBM Plex Sans Thai' fontSize={16} fontWeight={700}>
        ไฟล์หลักฐาน
      </Text>
      <br />
      <Text fontFamily='Sarabun' fontSize={14} fontWeight={400} color='background4'>
        โปรดเลือกไฟล์หลักฐานการอนุมัติคำขอวงเงินที่ผ่านการอนุมัติแล้วเท่านั้น
      </Text>

      <Row>
        <Col span={12}>
          <Form.Item
            style={{ marginLeft: "24px" }}
            name='file'
            rules={[{ required: true, message: "กรุณาอัปโหลดไฟล์" }]}
          >
            <UploadFilePDFCreditLimit
              onFileUpload={(file) => {
                form.setFieldsValue({ file: file });
                onFileUpload(file);
              }}
              value={afterStatus !== "APPROVED" ? (pathFile ? pathFile.name : null) : null}
            />
          </Form.Item>
        </Col>
      </Row>

      {afterStatus === "APPROVED" && (
        <>
          <Text fontSize={16} fontWeight={700}>
            เปิด/ปิดใช้งาน
          </Text>
          <br />
          <Form.Item
            style={{ marginLeft: "24px" }}
            name='isActive'
            rules={[{ required: true, message: "กรุณาอัปโหลดไฟล์" }]}
          >
            <Radio.Group
              value={isActive}
              onChange={(e) => {
                setIsActive(e.target.value);
              }}
            >
              <Space direction='vertical'>
                <Radio value={true}>
                  <Text fontFamily='Sarabun' fontSize={14}>
                    เปิดใช้งาน
                  </Text>
                </Radio>
                <Radio value={false}>
                  <Text fontFamily='Sarabun' fontSize={14}>
                    ปิดใช้งาน
                  </Text>
                </Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </>
      )}
    </Container>
  );
};

export default ApprovalSection;
